import * as types from './mutation-types';
import * as actions from './actions';

const state = {
    intervals: [],
}
const getters = {
    intervals: state => state.intevals,
}

const mutations = {
    [types.ADD_INTERVAL](state, intervalId) {
        state.intervals.push(intervalId)
    },
    [types.CLEAR_INTERVALS](state) {
        state.intervals.forEach(interval => clearInterval(interval))
        state.intervals = []
    },
}

export default{
    state,
    actions,
    getters,
    mutations
}
